import { withMediaProps } from "react-media-player";
import { usePodcastProvider } from "components/podcast/PodcastProvider";
import { secondsToHms } from "services/utils";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";
//ui
import { Box, Flex, Slider, SliderTrack, SliderFilledTrack, SliderThumb, Tooltip } from "@chakra-ui/react";
import { IndicatorIcon } from "components/icons";
import PodcastColorTypes from "types/podcastColorTypes";

export interface MediaProps {
  addVolume: (amount: number) => void;
  fullScreen: () => void;
  muteUnmute: () => void;
  seekTo: (currentTime: number) => void;
  setVolume: (volume: number) => void;
  skipTime: (amount: number) => void;
  stop: () => void;
  pause: () => void;
  play: () => void;
  playPause: () => void;
  mute: (isMuted: boolean) => void;
  currentTime: number;
  duration: number;
  progress: number;
  volume: number;
  isFullScreen: boolean;
  isLoading: boolean;
  isMuted: boolean;
  isPlaying: boolean;
}

interface MediaSliderProps {
  media?: MediaProps;
  detailSmallScreens?: boolean;
}
function MediaSlider({ media, detailSmallScreens }: MediaSliderProps) {
  const { playingPodcast } = usePodcastProvider();
  const duration = playingPodcast ? Number(playingPodcast.length) / 1000 : 0;
  const value = media && media.currentTime > 0 ? (media.currentTime / duration) * 100 - 3 : 0;
  const currentTime = media ? secondsToHms((media.currentTime * 1000).toString()) : 0;

  const changeRange = (range: number) => {
    if (media) {
      media.seekTo((range * duration) / 100);
      media.play();
    }
  };
  const trackColor = detailSmallScreens ? `${getPodcastThemeToken(PodcastColorTypes.DetailsMediaTrack)}` : `${getPodcastThemeToken(PodcastColorTypes.MediaTrack)}`;
  const filledTrackColor = detailSmallScreens ? `${getPodcastThemeToken(PodcastColorTypes.DetailsMediaFilledTrack)}` : `${getPodcastThemeToken(PodcastColorTypes.MediaFilledTrack)}`;
  const borderColor = detailSmallScreens ? `${getPodcastThemeToken(PodcastColorTypes.DetailsMediaFilledTrack)}` : `${getPodcastThemeToken(PodcastColorTypes.MediaFilledTrack)}`;

  return (
    <Flex width="100%" flexDir="column">
      <Slider aria-label="slider-ex-4" width="100%" borderWidth="0px" transition="all 0.1s" defaultValue={value} max={100} value={value} onChange={changeRange}>
        <SliderTrack padding="0" height="12px" bg={{ base: trackColor, md: `${getPodcastThemeToken(PodcastColorTypes.MediaTrack)}` }} borderRadius="16px" borderWidth="0px" borderColor="transparent">
          <SliderFilledTrack bg={{ base: filledTrackColor, md: `${getPodcastThemeToken(PodcastColorTypes.MediaFilledTrack)}` }} style={{ width: "30% !important" }} />
        </SliderTrack>
        <Tooltip hasArrow label={currentTime} bg={`${getPodcastThemeToken(PodcastColorTypes.MediaTooltipBackground)}`} color="white" placement="top" borderRadius="8px">
          <SliderThumb
            width="32px"
            bg="gray.150"
            height="32px"
            border={`2px solid ${getPodcastThemeToken(PodcastColorTypes.MediaFilledTrack)}`}
            borderColor={borderColor}
            style={{ left: `calc(30% - 16px)` }}
          >
            <Box color={`${getPodcastThemeToken(PodcastColorTypes.MediaFilledTrack)}`} height="8px" as={IndicatorIcon} />
          </SliderThumb>
        </Tooltip>
      </Slider>
    </Flex>
  );
}

export const CustomMediaSlider = withMediaProps(MediaSlider);
